import { useNavigate } from "react-router-dom";
import { Shield, Star, MapPin } from "lucide-react";

export default function HostCard({ host, index = 0 }) {
  const navigate = useNavigate();
  return (
    <button
      data-testid={`host-card-${host.id}`}
      onClick={() => navigate(`/host/${host.id}`)}
      style={{ animationDelay: `${index * 60}ms` }}
      className="fade-up text-left bg-white rounded-2xl border border-border overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
    >
      <div className="relative h-56 overflow-hidden">
        <img src={host.avatar_url || `https://api.dicebear.com/7.x/initials/svg?seed=${host.name}`}
          alt={host.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute top-3 right-3 bg-sage text-white text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1 shadow">
          <Shield className="w-3.5 h-3.5" strokeWidth={2} /> {host.trust_score}% Trusted
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-center justify-between">
          <h3 className="font-display text-xl font-bold text-charcoal">{host.name}{host.age ? `, ${host.age}` : ""}</h3>
          {host.rating && (
            <span className="flex items-center gap-1 text-sm font-semibold text-charcoal/70">
              <Star className="w-4 h-4 fill-sun text-sun" /> {host.rating}
            </span>
          )}
        </div>
        <p className="text-sm text-charcoal/60 flex items-center gap-1 mt-1"><MapPin className="w-3.5 h-3.5" /> {host.city || "Bengaluru"}</p>
        <p className="text-sm text-charcoal/70 mt-2 line-clamp-2 leading-relaxed">{host.bio}</p>
        <div className="flex flex-wrap gap-1.5 mt-3">
          {(host.interests || []).slice(0, 3).map((i) => (
            <span key={i} className="text-xs font-semibold bg-sand text-charcoal/70 px-2.5 py-1 rounded-full">{i}</span>
          ))}
        </div>
      </div>
    </button>
  );
}
